export const SITE = {
    name: "Studio Shakthi",
    tagline: "To Disrupt the Status Quo",
    subtitle: "Karpanai Virpanai",
    subtitleEn: "Imagine, Create, Distribute",
    summary:
        "A content creation company specializing in the entertainment space — building emotion-led cinema for a global audience.",
    contactEmail: "bsradha@studioshakthi.com",
    locationHQ: "Chennai · India",
};

export const PHILOSOPHY = [
    "Storytelling meets technology.",
    "We make films and series that travel — across languages, platforms, and borders.",
    "Every frame is engineered for emotion; every release is engineered for reach.",
];

export const FOUNDER = {
    name: "B.S. Radhakrishnan",
    role: "Founder",
    quote:
        "The next decade of cinema will be defined not by territory, but by craft.",
    bio: [
        "A second-generation entertainment entrepreneur with over three decades of experience, B.S. Radhakrishnan has built a distinguished career at the intersection of content, technology, distribution, and media operations. Having worked across virtually every segment of the entertainment ecosystem, he brings a rare end-to-end understanding of how stories are created, distributed, monetized, and scaled.",
        "Over the course of his career, Radhakrishnan has held leadership positions across some of India's most influential media and entertainment companies, including Radaan Mediaworks, K Sera Sera Group, Asia Digital Entertainment, Southern Digital Screenz, Truevision Communications, and Kavi Puvi Viamedia. His experience spans film and television production, theatrical distribution, digital cinema, broadcast technology, OTT platforms, content strategy, and media entrepreneurship.",
        "As Founder of Studio Shakthi Pictures, he leads the company's overall vision, strategy, and growth. Under his leadership, Studio Shakthi is building a diversified entertainment ecosystem spanning feature films, digital content, international collaborations, and entertainment-focused education initiatives. His deep understanding of both traditional and emerging media landscapes enables the company to identify opportunities at the convergence of storytelling, technology, and audience engagement.",
        "Driven by a lifelong passion for cinema and innovation, Radhakrishnan continues to champion projects that combine strong creative vision with sustainable business models, positioning Studio Shakthi as a next-generation entertainment company with a global outlook.",
    ],
    portrait: "/assets/founder-bsr.jpg",
};

export const TEAM = [
    {
        slug: "girishh-gopalakrishnan",
        name: "Girishh Gopalakrishnan",
        role: "Director, Studio Shakthi Pictures",
        image: "/assets/girishh.jpg",
        monogram: "GG",
        bio: [
            "A composer, filmmaker, and creative entrepreneur, Girishh Gopalakrishnan brings over 14 years of experience in storytelling across cinema, music, and digital entertainment. Since his debut as a film composer with the acclaimed Tamil feature Marina (2012), he has built a diverse body of work spanning blockbuster films, streaming originals, independent productions, and international collaborations.",
            "His credits include celebrated projects such as Aval, Mookuthi Amman, Netrikann, Kolai, and the streaming series The Village, alongside his work on Coke Studio Tamil Season 2. His experience across Indian and UK productions has given him a unique cross-cultural perspective on content creation and audience engagement.",
            "As a Director at Studio Shakthi Pictures, Girishh plays a key role in shaping the company's creative vision, overseeing the development of films, series, and emerging entertainment formats. His blend of artistic excellence, production expertise, and global outlook continues to drive Studio Shakthi's mission of creating stories that resonate across cultures and generations.",
        ],
    },
    {
        slug: "k-santosh-kumar",
        name: "K. Santosh Kumar",
        role: "Chief Operating Officer (COO), Studio Shakthi Pictures",
        image: "/assets/santosh.png",
        monogram: "SK",
        bio: [
            "With more than two decades of experience across film, television, digital content, and advertising, K. Santosh Kumar serves as the Chief Operating Officer of Studio Shakthi Pictures, overseeing the company's operational strategy and execution across all business verticals.",
            "Having built his career from the ground up, Santosh possesses a rare combination of hands-on production expertise and executive leadership experience. His journey from production management to company leadership has given him a comprehensive understanding of every stage of content creation, from development and budgeting to production, post-production, and final delivery.",
            "As COO, Santosh is responsible for driving operational excellence across Studio Shakthi's film, digital content, and education initiatives. He leads project execution, resource planning, financial oversight, vendor and partner relationships, risk management, and organizational processes, ensuring that the company's creative vision is supported by efficient and scalable operations.",
            "Throughout his career, Santosh has successfully delivered productions spanning more than 1,500 episodes of television content, feature films, streaming projects, branded entertainment, and advertising campaigns. His leadership has been instrumental in managing complex productions, including the acclaimed streaming series The Village and the feature film Rihana, while maintaining the highest standards of quality, efficiency, and fiscal discipline.",
            "At Studio Shakthi Pictures, Santosh plays a central role in transforming creative ambition into operational reality, helping build a company capable of developing and delivering world-class entertainment for both Indian and international audiences.",
        ],
    },
    {
        slug: "pranava-kumara-guru",
        name: "Pranava Kumara Guru",
        role: "Executive Producer, Studio Shakthi Pictures",
        image: "/assets/pranav.png",
        monogram: "PG",
        bio: [
            "Pranava Kumara Guru brings together expertise in business development, finance, strategic partnerships, and film production. With a professional background spanning enterprise SaaS, digital platforms, and the entertainment industry, he combines commercial acumen with a deep understanding of content businesses and creative ecosystems.",
            "Before joining Studio Shakthi Pictures, Pranava built a successful career in business development and account management, leading revenue growth initiatives and managing strategic client relationships at companies including Freshworks, Zomato, and EY. His experience in sales, financial analysis, and stakeholder management provides a strong foundation for scaling creative ventures and building sustainable business models.",
            "As Executive Producer at Studio Shakthi Pictures, Pranava is responsible for the strategic and commercial aspects of the company's projects, overseeing development, financing, partnerships, production operations, and distribution initiatives. He has played a key role in the international positioning of feature film projects, managing festival submissions, cross-border collaborations, stakeholder relationships, production finance, and release planning.",
        ],
    },
];

export const PROJECTS = [
    {
        slug: "the-village",
        title: "The Village",
        status: "Released",
        role: "End-to-End Production",
        platform: "Amazon Prime Video",
        year: "2023",
        tagline:
            "A folklore-noir series — engineered by Studio Shakthi from script to stream.",
        description:
            "Studio Shakthi handled The Village end-to-end for Amazon Prime Video — overseeing development, production, post, and platform delivery. A genre-fluid series that blends rural folklore with high-craft cinematic horror.",
        tags: ["Series", "End-to-End", "OTT Delivery"],
        image: "/assets/the-village-poster.jpg",
        imdb: "https://www.imdb.com/title/tt21882650/",
        accent: "ember",
    },
    {
        slug: "rihana",
        title: "Rihana",
        status: "Released",
        role: "Post-Production · Cannes Delivery",
        platform: "Marché du Film · Cannes",
        year: "2026",
        tagline:
            "A feature finished for the world stage — color, sound, and market delivery.",
        description:
            "Studio Shakthi managed post-production and Cannes market delivery on Rihana — handling color, sound, DCP mastering and festival ingestion to ensure a clean global premiere window.",
        tags: ["Feature", "Post-Production", "Festival Delivery"],
        image: "/assets/rihana-poster.jpg",
        imdb: "https://www.imdb.com/title/tt42131235/",
        accent: "teal",
    },
    {
        slug: "amor",
        title: "AMOR",
        status: "Upcoming",
        role: "In Development",
        platform: null,
        year: "TBA 2026-27",
        tagline: "A love story for a fractured world. Details coming soon.",
        description:
            "AMOR is currently in development at Studio Shakthi. More details will be revealed closer to release.",
        tags: ["Upcoming", "Feature"],
        image: null,
        accent: "gold",
    },
    {
        slug: "2five4",
        title: "2Five4",
        status: "Upcoming",
        role: "In Development",
        platform: null,
        year: "TBA 2027-28",
        tagline: "A coded title for an uncoded story. Details coming soon.",
        description:
            "2Five4 is currently in development at Studio Shakthi. More details will be revealed closer to release.",
        tags: ["Upcoming", "Series"],
        image: null,
        accent: "teal",
    },
];

export const CAPABILITIES = [
    {
        slug: "feature-films",
        title: "Feature Films",
        label: "01 / Production",
        description:
            "Theatrical-grade cinema, developed and produced with seasoned departments — story first, craft always.",
    },
    {
        slug: "web-series",
        title: "Web Series",
        label: "02 / Production",
        description:
            "Episodic storytelling built for the streaming era. Long arcs, cinematic craft, platform-native delivery.",
    },
    {
        slug: "end-to-end-production",
        title: "End-to-End Production",
        label: "03 / Production",
        description:
            "Concept to release. We carry projects through development, shoot, post, and platform handover.",
    },
    {
        slug: "post-production",
        title: "Post-Production",
        label: "04 / Finishing",
        description:
            "Picture and sound finishing — color, conform, mix, mastering — calibrated for theatrical and OTT.",
    },
    {
        slug: "festival-market-delivery",
        title: "Festival & Market Delivery",
        label: "05 / Distribution",
        description:
            "DCPs, KDMs, market screeners, festival submissions and Cannes-grade ingestion handled by our team.",
    },
    {
        slug: "global-distribution",
        title: "Global Distribution",
        label: "06 / Distribution",
        description:
            "Worldwide platform partnerships and language strategy to take stories beyond their first market.",
    },
    {
        slug: "micro-series",
        title: "Micro-Series",
        label: "07 / New Formats",
        description: "Short-form vertical video — coming soon.",
        comingSoon: true,
    },
];

export const CITIES = [
    { name: "Chennai", note: "Headquarters", x: 70, y: 52 },
    { name: "Mumbai", note: "Production", x: 66, y: 48 },
    { name: "Cannes", note: "Marché du Film", x: 49, y: 36 },
    { name: "London", note: "Partners", x: 46, y: 30 },
    { name: "Los Angeles", note: "Distribution", x: 14, y: 40 },
    { name: "New York", note: "Distribution", x: 26, y: 38 },
    { name: "Dubai", note: "Co-production", x: 60, y: 46 },
    { name: "Singapore", note: "OTT Partners", x: 78, y: 60 },
];

export const PARTNERS = [
    "Amazon Prime Video",
    "Marché du Film · Cannes",
    "Festival Partners",
    "OTT Networks",
    "Sound Stage",
    "Color Labs",
    "Distribution Houses",
];
